import React from 'react';
import '../css/LegalPages.css';

const TermsPage = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <h1>Terms of Service</h1>
        <p>Effective Date: February 4, 2026</p>
      </section>

      <section className="legal-section">
        <h2>1. Service Scope</h2>
        <p>
          BlinkURL provides URL shortening and analytics features for personal and business use. By using the platform, you agree
          to use it lawfully and responsibly.
        </p>
      </section>

      <section className="legal-section">
        <h2>2. Acceptable Use</h2>
        <p>
          You may not use BlinkURL for malicious links, phishing, malware distribution, unlawful content, or deceptive activity.
          We reserve the right to suspend abuse-related accounts and links.
        </p>
      </section>

      <section className="legal-section">
        <h2>3. Availability</h2>
        <p>
          We aim for high uptime, but service interruptions may occur during maintenance, updates, or incidents beyond our control.
        </p>
      </section>

      <section className="legal-section">
        <h2>4. Limitation of Liability</h2>
        <p>
          BlinkURL is provided on an “as is” basis. To the maximum extent permitted by law, we are not liable for indirect or
          consequential damages arising from service use.
        </p>
      </section>
    </div>
  );
};

export default TermsPage;
